import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// Pages
import CheckEmailMessagePage from "pages/LoginOrRegisterPages/CheckEmailMessagePage/CheckEmailMessagePage";
import ContinueToAccountOrLogoutPage from "pages/ContinueToAccountOrLogoutPage/ContinueToAccountOrLogoutPage";
import CreatePasswordPage from "pages/RegistrationPages/CreatePasswordPage/CreatePasswordPage";
import LoadingPage from "pages/LoadingPage/LoadingPage";
import TokenExpiredPage from "pages/RegistrationPages/TokenExpiredPage/TokenExpiredPage";

// Actions
import { validateToken } from "store/slices/accountSlice";
import {
  setContent,
  setEmailAddress,
  setResetPassword,
  setToken,
} from "store/slices/applicationSlice";
import { setLoader } from "store/slices/loadersSlice";

export default function RegistrationPages() {
  const { email, token } = useParams();
  const { content } = useSelector(({ application }) => application);
  const { isLoader } = useSelector(({ loaders }) => loaders);

  const isResetPassword = window.location.href.indexOf("/reset-password") !== -1;

  // Redux
  const reduxDispatch = useDispatch();

  // Constants
  const PAGES = Object.freeze({
    checkMail: <CheckEmailMessagePage />,
    continueToAccountOrLogoutPage: <ContinueToAccountOrLogoutPage />,
    createPassword: <CreatePasswordPage />,
    tokenExpired: <TokenExpiredPage />,
  });

  useEffect(() => {
    reduxDispatch(setResetPassword(isResetPassword));
    reduxDispatch(setToken(token));
    reduxDispatch(setEmailAddress(email));

    reduxDispatch(validateToken()).then(result => {
      const { isValid } = result.payload;
      const redirectToPage = isValid ? "createPassword" : "tokenExpired";

      reduxDispatch(setContent(redirectToPage));
      reduxDispatch(setLoader(false));
    });
  }, []);

  return isLoader ? (
    <LoadingPage title="Welcome" content="Validating your request" />
  ) : (
    PAGES[content]
  );
}
